import React from "react";

const TopSellingItem = () => {
    const tableItems = [1, 2, 3, 4];
    return (
        <>
            {
                tableItems.map((item, id) =>
                    <ul className="_selling_main_table_item_wrapper">
                        <li className="_selling_main_table_item">
                            <span className="_selling_main_table_item_num">{item}</span>
                            <img src={`assets/img/topsell${item}.png`} alt="" className="_selling_main_table_item_img" />
                            <p className="_selling_main_table_item_name">Bored Ape Yacht Club</p>
                        </li>
                        <li className="_selling_main_table_item">
                            10,450.00
                        </li>
                        <li className="_selling_main_table_item">
                            <p className="_fav_main_table_item_red">
                                -48.9%
                            </p>
                        </li>
                        <li className="_selling_main_table_item">
                            <p className="_fav_main_table_item_green">
                                +28.9%
                            </p>
                        </li>
                        <li className="_selling_main_table_item">
                            {
                                item === 1 &&
                                <span className="_selling_main_table_item_ic"><svg xmlns="http://www.w3.org/2000/svg"
                                    width="21" height="21" fill="none" viewBox="0 0 21 21">
                                    <path fill="#03DB80" fill-rule="evenodd"
                                        d="M14.792 5.258a1.3 1.3 0 0 0-1.299 1.301V7.6h4.22v3.969h-4.285v1.691c0 3.126-2.53 5.66-5.65 5.66a5.655 5.655 0 0 1-5.65-5.66c0-3.126 2.53-5.66 5.65-5.66h1.819V6.56a5.2 5.2 0 0 1 5.195-5.206h4.903v3.904h-4.903ZM9.596 7.632v3.937h3.832V7.632H9.596ZM6.025 13.26c0-.97.785-1.757 1.753-1.757h1.754v1.757a1.755 1.755 0 1 1-3.507 0Z"
                                        clip-rule="evenodd" />
                                </svg>
                                </span>
                            }
                            {
                                item === 2 &&
                                <span className="_selling_main_table_item_ic"><svg xmlns="http://www.w3.org/2000/svg"
                                    width="21" height="21" fill="none" viewBox="0 0 21 21">
                                    <path fill="#6B8CEF" fill-rule="evenodd"
                                        d="m10.916.3 6.27 10.224-6.27 3.642V7.723l5.49 2.452-5.49-2.453V.3Zm-.002 0v7.422l-5.49 2.454 5.49-2.453v6.443l-6.27-3.642L10.914.301Zm0 15.034v5.042L4.64 11.693l6.274 3.64Zm.002 5.042v-5.043l6.27-3.64-6.27 8.683Z"
                                        clip-rule="evenodd" />
                                </svg>
                                </span>
                            }
                            {
                                item === 3 &&
                                <span className="_selling_main_table_item_ic"><svg xmlns="http://www.w3.org/2000/svg"
                                            width="21" height="21" fill="none" viewBox="0 0 21 21">
                                            <path fill="#2C7DF7"
                                                d="M12.299 20.575c-1.343 0-2.321-.345-2.936-1.035-.614-.69-.921-1.433-.921-2.23 0-.292.053-.537.16-.736a1.22 1.22 0 0 1 .44-.472c.185-.115.414-.172.686-.172.271 0 .5.057.685.172.186.115.332.273.44.472.107.2.16.444.16.736 0 .352-.078.64-.235.862-.158.222-.344.368-.558.437.186.276.48.471.88.586.4.123.8.184 1.199.184.557 0 1.06-.16 1.51-.483.45-.322.783-.797.998-1.425.214-.629.321-1.342.321-2.139 0-.866-.118-1.606-.354-2.219-.228-.62-.568-1.08-1.018-1.38a2.584 2.584 0 0 0-1.457-.448c-.343 0-.771.153-1.286.46l-.943.506v-.506l4.243-6.07H8.442v6.3c0 .52.107.95.321 1.287.214.338.543.506.986.506.342 0 .671-.122.986-.368.316-.247.591-.55.814-.896a.335.335 0 0 1 .107-.15.205.205 0 0 1 .14-.057c.078 0 .17.042.278.126.1.123.15.265.15.425a2.94 2.94 0 0 1-.054.323c-.242.582-.578 1.027-1.007 1.333-.417.303-.91.463-1.414.46-1.272 0-2.15-.268-2.636-.805-.486-.536-.729-1.265-.729-2.184v-6.3h-3V4.5h3V1.834L5.7 1.097V.5h1.99l.75.414V4.5l7.758-.023.772.828-4.758 5.105c.289-.123.592-.2.9-.23.515 0 1.093.176 1.736.529.65.345 1.15.82 1.5 1.425.35.598.575 1.174.675 1.725a7.82 7.82 0 0 1 .161 1.472c0 .981-.193 1.893-.578 2.737-.386.843-.972 1.471-1.758 1.885a5.39 5.39 0 0 1-2.55.621Z" />
                                        </svg>
                                        </span> 
                            }
                            {
                                item === 4 &&
                                <span className="_selling_main_table_item_ic"><svg xmlns="http://www.w3.org/2000/svg"
                                    width="21" height="21" fill="none" viewBox="0 0 21 21">
                                    <path fill="#03DB80" fill-rule="evenodd"
                                        d="M14.792 5.258a1.3 1.3 0 0 0-1.299 1.301V7.6h4.22v3.969h-4.285v1.691c0 3.126-2.53 5.66-5.65 5.66a5.655 5.655 0 0 1-5.65-5.66c0-3.126 2.53-5.66 5.65-5.66h1.819V6.56a5.2 5.2 0 0 1 5.195-5.206h4.903v3.904h-4.903ZM9.596 7.632v3.937h3.832V7.632H9.596ZM6.025 13.26c0-.97.785-1.757 1.753-1.757h1.754v1.757a1.755 1.755 0 1 1-3.507 0Z"
                                        clip-rule="evenodd" />
                                </svg>
                                </span>
                            }
                            4315
                        </li>
                        <li className="_selling_main_table_item">
                            6.3k
                        </li>
                        <li className="_selling_main_table_item">
                            10k
                        </li>
                    </ul>
                )
            }
        </>
    )
}

export default TopSellingItem;